import { render, staticRenderFns } from "./CreateUserModal.vue?vue&type=template&id=64956a75&scoped=true&"
import script from "./CreateUserModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64956a75",
  null
  
)

export default component.exports